import React, { useContext } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { DisplayDiscussionForMiniScreenContext } from "../../contexts/DisplayDiscussionForMiniScreenContext";
import { BsSearch } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Person from "../Person";

export default function GroupeInfo({ show, setShow, enleverRecherche, typingUsers = [] }) {
  const { setDisplayDiscussionForMiniScreen, crew, setCrew } = useContext(
    DisplayDiscussionForMiniScreenContext
  );

  return (
    <>
      <ul className="tyn-list-inline d-md-none ms-n1">
        <li>
          <button
            className="btn btn-icon btn-md btn-pill btn-transparent js-toggle-main"
            onClick={() => {
              setCrew(null);
              setDisplayDiscussionForMiniScreen(false);
            }}
          >
            <FaChevronLeft />
          </button>
        </li>
      </ul>
      <div className="tyn-media-group">
        <div className="tyn-media tyn-size-lg d-none d-sm-inline-flex">
          <div style={{ height: "100%", width: "100%" }}>
            <Person
              person={{
                image: crew.imageUrl || "",
                prenom: crew.nom,
                nom: crew.nom[1],
                userId: crew.userId,
                colors: crew.color,
              }}
            />
          </div>
        </div>

        <div className="tyn-media tyn-size-rg d-sm-none">
          <div style={{ height: "100%", width: "100%" }}>
            <Person
              person={{
                image: crew.imageUrl || "",
                prenom: crew.nom,
                nom: crew.nom[1],
                userId: crew.userId,
                colors: crew.color,
              }}
            />
          </div>
        </div>

        <div className="tyn-media-col">
          <div className="tyn-media-row">
            <h6 className="name">{crew.nom}</h6>
          </div>
          <div className="tyn-media-row has-dot-sap">
            {typingUsers.length > 0 &&
              typingUsers.map((writter, idx) => (
                <span
                  key={idx}
                  className={`meta text-success ${
                    writter ? "my-text-writting-alternate-infinite" : ""
                  }`}
                >
                  {writter.prenom + " écrit..."}
                </span>
              ))}
          </div>
        </div>
      </div>
      {!enleverRecherche ? (
        <div
          className={`tyn-chat-search ${show ? "active" : ""}`}
          id="tynChatSearch"
        >
          <div className="flex-grow-1">
            <div className="form-group">
              <div className="form-control-wrap form-control-plaintext-wrap">
                <div className="form-control-icon start">
                  <BsSearch />
                </div>
                <input
                  type="text"
                  className="form-control form-control-plaintext"
                  id="searchInThisChat"
                  placeholder="Recherchez un méssage"
                />
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center gap gap-3">
            <ul className="tyn-list-inline ">
              <li>
                <button className="btn btn-icon btn-sm btn-transparent">
                  <FaChevronUp />
                </button>
              </li>
              <li>
                <button className="btn btn-icon btn-sm btn-transparent">
                  <FaChevronDown />
                </button>
              </li>
            </ul>
            <ul className="tyn-list-inline ">
              <li>
                <button
                  className="btn btn-icon btn-md btn-light js-toggle-chat-search"
                  onClick={() => setShow(false)}
                >
                  <RxCross2 />
                </button>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
